import { Container, Flex, VStack } from "@chakra-ui/react";
import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  IJwtContext,
  ILoadingContext,
  IUser,
  IUserContext,
} from "./types/types";

import axios from "axios";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Spinner from "./components/Spinner";
import Auth from "./pages/Auth";
import Booking from "./pages/Booking";
import BookingStarted from "./pages/BookingStarted";
import Bookings from "./pages/Bookings";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import ResetPassword from "./pages/ResetPassword";
import { UserService } from "./services/user.service";

export const UserContext = createContext<IUserContext>({} as IUserContext);
export const JwtContext = createContext<IJwtContext>({} as IJwtContext);
export const LoadingContext = createContext<ILoadingContext>(
  {} as ILoadingContext
);

const userService = new UserService();

const App: React.FC = () => {
  const [user, setUser] = useState<IUser | false>();

  const [jwt, setJwt] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  const saveJwt = () => {
    const local_jwt = localStorage.getItem("jwt");
    if (local_jwt) {
      setJwt(localStorage.getItem("jwt"));
    } else {
      setUser(false);
    }
  };

  useEffect(() => {
    saveJwt();
    window.addEventListener("storage", saveJwt);

    return () => {
      window.removeEventListener("storage", saveJwt);
    };
  }, []);

  useEffect(() => {
    getUser();

    // Add a request interceptor
    axios.interceptors.request.use((config) => {
      let local_jwt = localStorage.getItem("jwt");
      if (local_jwt) config.headers!["Authorization"] = "Bearer " + local_jwt;

      return config;
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jwt]);

  const getUser = () => {
    if (jwt) {
      userService
        .logged()
        .then(({ data }) => {
          console.log("[getUser] data", data);
          setUser(data);
        })
        .catch((err) => {
          console.log("[getUser] err", err);
          setUser(false);
        });
    }
  };

  return (
    <>
      <Flex direction={"column"} minH={"100vh"}>
        <UserContext.Provider
          value={{
            user,
            setUser,
            getUser,
          }}
        >
          <LoadingContext.Provider value={{ loading, setLoading }}>
            <BrowserRouter>
              {user === false ? (
                <Routes>
                  <Route path="/auth" element={<Auth />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route
                    path="/reset-password/:token"
                    element={<ResetPassword />}
                  />
                  <Route path="*" element={<Navigate to="/auth" />} />
                </Routes>
              ) : user === undefined ? (
                <Spinner fullscreen />
              ) : (
                <>
                  <Container maxW={"container.lg"} p={0}>
                    <Flex direction={"column"} minH={"100vh"}>
                      <Navbar />

                      <VStack flex={1} mb={8}>
                        <Routes>
                          <Route path="/" element={<Home />} />
                          <Route path="/booking" element={<Booking />} />
                          <Route
                            path="/booking-started"
                            element={<BookingStarted />}
                          />
                          <Route path="/bookings" element={<Bookings />} />
                          <Route path="/profile" element={<Profile />} />
                          <Route path="/login" element={<Navigate to="/" />} />
                          <Route path="*" element={<Navigate to="/" />} />
                        </Routes>
                      </VStack>

                      <Footer />
                    </Flex>
                  </Container>
                </>
              )}
            </BrowserRouter>
          </LoadingContext.Provider>
        </UserContext.Provider>
      </Flex>

      {loading && <Spinner />}
    </>
  );
};

export default App;
